import { apmBase } from "@elastic/apm-rum";
import { routeHooks } from "@elastic/apm-rum-vue/dist/lib/route-hooks";//"./ApmRouteHooks";
import { getErrorHandler } from "./ApmErrorHandler";

export const ApmVuePlugin = {
	install: (Vue, options) => {
		const { router, apm = apmBase, config, captureErrors = true } = options;
		/**
       * Initialize the APM with the config
       */
		apm.init(config);

		if (apm._initialized) {
			/**
         * Hook router if provided
         */
			if (router) {
				routeHooks(router, apm);
			}

			if (captureErrors) {
				/**
           * Global error handler for capturing errors during
           * component renders
           */
				Vue.config.errorHandler = getErrorHandler(Vue, apm);
			}
		}
		/**
       * Provide the APM instance via $apm to be accessed in all Vue Components
       */
		Vue.prototype.$apm = apm;
	}
};